var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Waiting for confirmation from MetaMask, check MetaMask to continue. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }